// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"36e47c8f","977":"a2ba3c65"}[chunkId] + ".chunk.js";
};